import { render, staticRenderFns } from "./JourneyForm.vue?vue&type=template&id=694649ee&"
import script from "./JourneyForm.vue?vue&type=script&lang=ts&"
export * from "./JourneyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports